import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const zoneApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getZones: builder.query({
      query: () => '/zones',
      providesTags: (result = [], error, arg) => [
        {type: 'Zone', id: 'LIST'},
        ...result.map(({ slug: id }) => ({ type: 'Zone', id }))
      ]
    }),
    getZone: builder.query({
      query: (zoneId) => `/zones/${zoneId}`,
      providesTags: (result, error, arg) => [{ type: 'Zone', id: arg }],
    }),
    createZone: builder.mutation({
      query: (zone) => ({
        url: 'zones/',
        method: 'POST',
        body: zone
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.created")}),
      invalidatesTags: (result, error, arg) => [{type: 'Zone', id: 'LIST'}],
    }),
    updateZone: builder.mutation({
      query: (zone) => ({
        url: `zones/${zone.key}`,
        method: 'PUT',
        body: zone,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, {key}) => [{ type: 'Zone', id: key }],
    })
  }),
  overrideExisting: false
})

export const {
  useGetZonesQuery,
  useGetZoneQuery,
  useUpdateZoneMutation,
  useCreateZoneMutation,
  useDeleteZoneMutation,
} = zoneApiSlice
